angular.module('Directives')
    .directive('ngLocation', function() {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/location.html',
            replace: true,
            scope: {
                options: '=?ngParams',
                ngModel: '=?ngModel',
                ngLocation: '=?ngLocation',
                readonly: '=?ngReadonly'
            },
            controller: function ($scope) {
                $scope.citySearchParams = false;
                $scope.countryModel = false;
                $scope.codeModel    = false;
                $scope.cityModel = false;

                var watchBool = false;

                var onChangeCountry = function(country) {
                    $scope.citySearchParams = false;

                    if (!($scope.codeModel && country && ($scope.codeModel.country == country))) {
                        $scope.codeAutocompleteOptions.localList = [];
                        $scope.stateAutocompleteOptions.localList = [];
                        $scope.cityAutocompleteOptions.localList = [];
                    }

                    if (country) {
                        $scope.citySearchParams = {
                            country: country.code
                        };
                        var code = $scope.codeAutocompleteOptions;
                        var city = $scope.cityAutocompleteOptions;
                        code.disabled = city.disabled = false;
                        $scope.stateAutocompleteOptions.placeholder = 'Enter the city name or the postcode';
                    } else {
                        $scope.stateAutocompleteOptions.placeholder = 'Enter the country location...';
                        var code = $scope.codeAutocompleteOptions;
                        var city = $scope.cityAutocompleteOptions;
                        code.disabled = city.disabled = true;
                    }
                };
                $scope.countryAutocompleteOptions = {
                    placeholder: 'Enter the country location',
                    textField: 'name',
                    searchField: 'name',
                    service: 'Country',
                    onChange: onChangeCountry
                };

                var onChangeCity = function(city) {
                    $scope.ngModel = false;
                    if (city) {
                        $scope.ngModel = {};
                        for (var k in city) {
                            if (k != 'codes') $scope.ngModel[k] = city[k];
                        }
                    }

                    if (city) {
                        if (city['codes']) {
                            $scope.codeAutocompleteOptions.localList = city['codes'];
                        }
                    } else {
                        $scope.codeAutocompleteOptions.localList = false;
                        $scope.stateAutocompleteOptions.localList = false;
                    }
                };

                var onChangeCode = function(city) {
                    $scope.ngModel = false;
                    if (city) {
                        $scope.ngModel = {};
                        for (var k in city) {
                            if (k != 'codes') $scope.ngModel[k] = city[k];
                        }
                    }
                    if (city) {
                        if (!city['codes']) {
                            $scope.cityAutocompleteOptions.localList = [city];
                        }
                        if (!city.state && city.code) {
                            $scope.stateAutocompleteOptions.placeholder = 'Unavailable';
                        }
                    } else {
                        $scope.stateAutocompleteOptions.localList = false;
                        $scope.cityAutocompleteOptions.localList = false;
                    }
                };

                $scope.stateAutocompleteOptions = {
                    placeholder: 'Enter the country location...',
                    textField: 'name',
                    disabled: true
                };
                $scope.cityAutocompleteOptions = {
                    placeholder: 'Enter the country location...',
                    textField: 'name',
                    searchField: 'name',
                    minQueryStringLength: 3,
                    groupBy: true,
                    disabled: true,
                    service: 'City',
                    onChange: onChangeCity
                };
                $scope.codeAutocompleteOptions = {
                    placeholder: 'Enter the country location...',
                    textField: 'code',
                    searchField: 'code',
                    minQueryStringLength: 3,
                    disabled: true,
                    service: 'City',
                    onChange: onChangeCode
                };

                $scope.$watch('ngLocation', function() {
                    if ($scope.ngLocation) {
                        $scope.countryModel = $scope.ngLocation.country;
                        $scope.countryAutocompleteOptions.localList = [$scope.ngLocation.country];
                        $scope.codeModel = $scope.ngLocation;
                        $scope.codeAutocompleteOptions.localList = [$scope.ngLocation];
                    } else {
                        $scope.countryAutocompleteOptions.localList = false;
                    }
                });

                $scope.$watch('ngModel', function() {
                    $scope.options && $scope.options.onChangeModelCallback ?
                        $scope.options.onChangeModelCallback($scope.ngModel) :
                        false;
                });
            }
        }
    });


// WEBPACK FOOTER //
// ./js/directives/location.js